/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SheetId } from "../../commons/types/SheetId";
import { WorkbookId } from "../../commons/types/WorkbookId";
import { SheetConfig } from "./SheetConfig";
import { RecordCounts } from "../../records/types/RecordCounts";
import { SheetTreatments } from "./SheetTreatments";
export const Sheet = core.serialization.object({
    id: SheetId,
    workbookId: WorkbookId,
    name: core.serialization.string(),
    slug: core.serialization.string(),
    config: SheetConfig,
    metadata: core.serialization.any().optional(),
    namespace: core.serialization.string().optional(),
    lockedBy: core.serialization.string().optional(),
    updatedAt: core.serialization.date(),
    createdAt: core.serialization.date(),
    lockedAt: core.serialization.date().optional(),
    recordCounts: RecordCounts.optional(),
    createdFrom: SheetId.optional(),
    lastPropagatedAt: core.serialization.date().optional(),
    treatments: core.serialization.list(SheetTreatments).optional(),
    collection: core.serialization.string().optional(),
});
